$(document).ready(function() {
  // on yes, start the session
  $('#ageGateYes').click(function() {
    sessionStorage.setItem('agePass','true');
  });
  // on no, give them the no-no and essentially do nothing
  $('#ageGateNo').click(function() {
    $('.age-gate-main-body').hide();
    $('.age-gate-denied-body').show();
    $('.age-gate-modal-footer').hide();
  });
});


// WEBPACK FOOTER //
// ./scripts/agegate.js